<template>
  <div class="content7-wrapper">
    <div class="content7">
      <div class="content7-header">
        <div class="content7-title1">强大&安全的产品及服务</div>
      </div>
      <div class="content7-list">
        <div 
          v-for="(item, index) in productList" 
          :key="index"
          class="content7-list-item"
          @mouseenter="active = index"
          @click="handleProductClick(item)"
        >
          <div :class="['content7-list-item-img', `content7-list-item-img${index + 1}`]"></div>
          <div class="content7-list-item-title">{{ item.title }}</div>
          <div 
            class="active_container"
            :class="{ active: active === index }"
          ></div>
        </div>
      </div>
      <div class="content7-d"></div>
      <div class="content7-card">
        <div 
          v-for="(card, index) in cardList" 
          :key="index"
          :class="[
            'content7-card-list',
            card.className,
            { active1: active === index }
          ]"
          @mouseenter="active = index"
          @click="handleCardClick(card)"
        >
          <div class="content7-card-list-title">
            {{ card.title }}
            <img v-if="card.hot" :src="hot2Img" width="34" alt="" />
          </div>
          <div class="content7-card-list-content">
            <p v-for="(p, pIndex) in card.content" :key="pIndex">{{ p }}</p>
          </div>
          <div class="content7-card-list-img">
            <img
              :src="card.img"
              :width="card.imgWidth"
              alt=""
              :class="{ 'active1-img': active === index }"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Img1 from '@/assets/7_2_1.png'
import Img2 from '@/assets/7_2_2.png'
import Img3 from '@/assets/7_2_3.png'
import Img4 from '@/assets/7_2_4.png'
import Img5 from '@/assets/7_2_5.png'
import Img6 from '@/assets/7_2_6.png'
import Hot2 from '@/assets/hot2.png'

export default {
  name: 'Content7',
  props: {
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      active: 0,
      hot2Img: Hot2,
      productList: [
        { title: '智慧城市', link: '/product#smartCity' },
        { title: '数字乡村', link: '/product#digitalVillage' },
        { title: '智慧教育', link: '/product#smartEducation' },
        { title: '智慧交通', link: '/product#smartTransport' },
        { title: '智慧应急', link: '/product#smartEmergency' },
        { title: '北斗定位', link: '/product#beidou' }
      ],
      cardList: [
        {
          title: '智慧城市',
          hot: true,
          className: 'content7-card-w1',
          content: ['智慧城市管理系统利用物联网、AI、5G、增强现实等信息技术，将城市的系统和服务打通，集成实现信息化、工业化与城镇化深度融合，提升资源利用效率，实现精细化管理，缓解"大城市病"，改善市民生活质量。'],
          img: Img1,
          imgWidth: 224,
          link: '/product#smartCity'
        },
        {
          title: '数字乡村',
          hot: true,
          className: 'content7-card-w2',
          content: ['数字乡村平台将物联网、传感器、大数据等前沿技术与传统农业深度融合，实现农业数据集成化、标准化提供农业"生产+治理+运营+服务"全链路解决方案为农业发展提供有力支撑，为乡村振兴开辟数字化新路径。'],
          img: Img2,
          imgWidth: 224,
          link: '/product#digitalVillage'
        },
        {
          title: '智慧教育',
          className: 'content7-card-s',
          content: [
            '校园安全风险防控解决方案',
            '校园安全应急管理解决方案'
          ],
          img: Img3,
          imgWidth: 145,
          link: '/product#smartEducation'
        },
        {
          title: '智慧交通',
          className: 'content7-card-s',
          content: [
            '交通信息动态监管解决方案',
            '城市道路节点管理解决方案'
          ],
          img: Img4,
          imgWidth: 145,
          link: '/product#smartTransport'
        },
        {
          title: '智慧应急',
          className: 'content7-card-s',
          content: [
            '应急指挥调度解决方案',
            '应急预案推演解决方案'
          ],
          img: Img5,
          imgWidth: 145,
          link: '/product#smartEmergency'
        },
        {
          title: '北斗定位',
          className: 'content7-card-s',
          content: [
            '运营车辆可视化管理解决方案',
            '交通运输行业智能化管理解决方案'
          ],
          img: Img6,
          imgWidth: 145,
          link: '/product#beidou'
        }
      ]
    }
  },
  methods: {
    viewAllProducts() {
      this.$router.push('/product')
    },
    handleCardClick(card) {
      if (card.link) {
        this.$router.push(card.link)
      }
    },
    handleProductClick(product) {
      if (product.link) {
        this.$router.push(product.link)
      }
    }
  }
}
</script>

<style scoped>
.content7-wrapper {
  background: linear-gradient(180deg, #f8f9fa 0%, #ffffff 100%);
  overflow: hidden;
  position: relative;
  color: #242934;
}

.content7 {
  background: transparent;
  padding-top: 100px;
  padding-bottom: 120px;
  max-width: 1400px;
  margin: 0 auto;
}

.content7-d {
  margin-top: 60px;
  width: 100%;
  height: 1px;
  background: linear-gradient(90deg, transparent, #e3e6ec, transparent);
  max-width: 1400px;
  margin-left: auto;
  margin-right: auto;
}

.content7-header {
  padding: 0 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 60px;
}

.content7-title1 {
  font-size: 42px;
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
  font-weight: 600;
  color: #1a1a1a;
  letter-spacing: -0.5px;
  position: relative;
}

.content7-title1::after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 0;
  width: 60px;
  height: 4px;
  background: linear-gradient(90deg, #1890ff, #40a9ff);
  border-radius: 2px;
}

.content7-title2 {
  cursor: pointer;
  font-size: 16px;
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
  color: #1890ff;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
}

.content7-title2:hover {
  color: #40a9ff;
  transform: translateX(5px);
}

.content7-card {
  margin: 80px auto 0;
  max-width: 1320px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
  padding: 0 40px;
}

.content7-card-list.active1 {
  box-shadow: 0px 20px 60px 0px rgba(24, 144, 255, 0.15) !important;
  transform: translateY(-8px);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.content7-card-list {
  cursor: pointer;
  position: relative;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.content7-card-list:hover {
  transform: translateY(-5px);
  box-shadow: 0px 15px 40px 0px rgba(193, 205, 219, 0.6) !important;
}

.content7-card-list .active1-img {
  transition: all 0.3s ease;
  opacity: 1 !important;
}

.content7-card-list-title {
  margin-top: 48px;
  margin-left: 44px;
  height: 27px;
  font-size: 28px;
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
  font-weight: 600;
  color: #1a1a1a;
  line-height: 28px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.content7-card-list-title img {
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
}

.content7-card-list-content {
  margin-top: 26px;
  margin-left: 44px;
  width: 296px;
  font-size: 15px;
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
  font-weight: 400;
  color: #666;
  line-height: 1.8;
}

.content7-card-list-content p {
  margin-bottom: 8px;
}

.content7-card-list-content p:last-child {
  margin-bottom: 0;
}

.content7-card-list-img {
  position: absolute;
  right: 20px;
  bottom: 20px;
  z-index: 1;
}

.content7-card-list-img img {
  opacity: 0.4;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  filter: drop-shadow(0 4px 12px rgba(0, 0, 0, 0.1));
}

.content7-card-list.active1 .content7-card-list-img img,
.content7-card-list:hover .content7-card-list-img img {
  opacity: 0.8;
  transform: scale(1.1) translateY(-5px);
}

.content7-card-w1 {
  width: 608px;
  height: 318px;
  background: linear-gradient(135deg, #f0f7ff 0%, #ffffff 100%);
  box-shadow: 0px 8px 30px 0px rgba(193, 205, 219, 0.4);
  border-radius: 12px;
  border: 1px solid #e8f4ff;
}

.content7-card-w2 {
  width: 608px;
  height: 318px;
  background: linear-gradient(135deg, #f0fdf4 0%, #ffffff 100%);
  box-shadow: 0px 8px 30px 0px rgba(193, 205, 219, 0.4);
  border-radius: 12px;
  border: 1px solid #e8f8f0;
}

.content7-card-s {
  width: 291px;
  height: 327px;
  background: linear-gradient(135deg, #f0f7ff 0%, #ffffff 100%);
  box-shadow: 0px 8px 30px 0px rgba(193, 205, 219, 0.4);
  border-radius: 12px;
  border: 1px solid #e8f4ff;
}

.content7-card-s .content7-card-list-content {
  margin-top: 26px;
  margin-left: 44px;
  width: 168px;
  font-size: 14px;
  font-family: Source Han Sans SC;
  font-weight: 400;
  color: #242934;
  line-height: 28px;
}

.content7-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  margin-top: 60px;
  padding: 0 40px;
  gap: 30px;
}

.content7-list-item {
  position: relative;
  cursor: pointer;
  padding: 15px;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.content7-list-item:hover {
  background: rgba(24, 144, 255, 0.05);
  transform: translateY(-3px);
}

.active_container {
  position: absolute;
  bottom: -8px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 3px;
  background: linear-gradient(90deg, #1890ff, #40a9ff);
  border-radius: 2px;
  transition: width 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.active_container.active {
  width: 50px;
}

.content7-list-item-img {
  width: 64px;
  height: 64px;
  margin: 0 auto 12px;
  transition: all 0.3s ease;
}

.content7-list-item:hover .content7-list-item-img {
  transform: scale(1.1);
}

.content7-list-item-img1 {
  background: url(@/assets/7_1.png) no-repeat center center / 100% 100%;
}

.content7-list-item-img2 {
  background: url(@/assets/7_2.png) no-repeat center center / 100% 100%;
}

.content7-list-item-img3 {
  background: url(@/assets/7_3.png) no-repeat center center / 100% 100%;
}

.content7-list-item-img4 {
  background: url(@/assets/7_4.png) no-repeat center center / 100% 100%;
}

.content7-list-item-img5 {
  background: url(@/assets/7_5.png) no-repeat center center / 100% 100%;
}

.content7-list-item-img6 {
  background: url(@/assets/7_6.png) no-repeat center center / 100% 100%;
}

.content7-list-item-title {
  font-size: 16px;
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
  font-weight: 500;
  color: #242934;
  text-align: center;
  transition: color 0.3s ease;
}

.content7-list-item:hover .content7-list-item-title {
  color: #1890ff;
}

@media screen and (max-width: 767px) {
  .content7 {
    padding: 60px 20px 40px;
  }
  
  .content7-header {
    padding: 0 20px;
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }
  
  .content7-title1 {
    font-size: 28px;
  }
  
  .content7-title1::after {
    left: 0;
  }
  
  .content7-list {
    padding: 0 20px;
    gap: 20px;
  }
  
  .content7-card {
    padding: 0 20px;
    gap: 20px;
  }
  
  .content7-card-w1,
  .content7-card-w2 {
    width: 100%;
    max-width: 100%;
  }
  
  .content7-card-s {
    width: 100%;
    max-width: 100%;
  }
}
</style>